// @flow
import * as React from 'react';
import decodeString from '@ta/common.decode';
import isDecodeSafe from './ObfuscationCheck';

// ObfuscatedLink props
export type Props = {|
  /** The browser window target ('_self' for same tab, '_blank' for new tab) */
  target?: '_blank' | '_self',

  /** A click event handler to be called prior to window.open. The original click event is not propagated */
  onClick?: (SyntheticMouseEvent<HTMLElement>) => mixed,

  /** The contained children within the link */
  children?: React.Node,

  /** Additional classes you'd like to add */
  className?: string,

  /** The encoded link generated using UserInterfaceUtil::obfuscateWord.
   * Used as the value for data-encoded-url, which can be read by ClickTracker and decoded client-side. */
  encodedUrl?: string,

  /** Any additional URL Arguments that should be appended to an encodedUrl after it is decoded. */
  urlArgs?: Object,

  /** Render with a span instead of a div when you don't want a block-level element. */
  useSpan?: boolean,

  requiresHttp?: boolean,
|};

/**
 * An SEO obfuscated link, encoded
 * In addition to what Obfuscated link (from common/routing) does, this class checks for existence of resource
 * /site/static/decodeKey.txt. This file is blocked by robots.txt. If the file is absent, the class will send back an empty String
 * and hence wont redirect
 */
class ProtectedObfuscatedLink extends React.Component<Props> {
  static defaultProps = {
    target: '_self',
    onClick: undefined,
    children: null,
    className: 'ui_link',
    encodedUrl: undefined,
    urlArgs: {},
    useSpan: false,
    requiresHttp: false,
  };
  openLink = () => {
    isDecodeSafe().then(value => {
      if (this.props.encodedUrl && value === true) {
        let decodedUrl = decodeString(this.props.encodedUrl);
        if (decodedUrl !== '') {
          if (this.props.requiresHttp) {
            decodedUrl = `http://${decodedUrl}`;
          }
          // eslint-disable-next-line no-restricted-globals
          const newWindow = window.open(decodedUrl, this.props.target);
          // popup blockers will cause newWindow to be null or undefined
          if (newWindow) {
            newWindow.opener = null;
          }
        }
      }
    });

    // blank url should no-op, rather than open an empty tab
  };

  handleClick = (event: SyntheticMouseEvent<HTMLElement>) => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
    this.openLink();
  };

  render() {
    return React.createElement(
      this.props.useSpan ? 'span' : 'div',
      {
        className: this.props.className,
        onClick: this.handleClick,
        'data-encoded-url': this.props.encodedUrl,
      },
      this.props.children,
    );
  }
}

export default ProtectedObfuscatedLink;
